module.exports = __webpack_public_path__ + "static/media/mh_entrium_07.136ed26e.png";